var MapEvent = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function MapEvent() {
    }
    MapEvent.maploaded = 'maploaded';
    MapEvent.zoomchanged = 'zoomchanged';
    MapEvent.extentchanged = 'extentchanged';
    MapEvent.centerchanged = 'centerchanged';
    MapEvent.blur = 'blur';
    MapEvent.click = 'click';
    MapEvent.doubleclick = 'doubleclick';
    MapEvent.drag = 'drag';
    MapEvent.focus = 'focus';
    MapEvent.hold = 'hold';
    MapEvent.keydown = 'key-down';
    MapEvent.keyup = 'key-up';
    MapEvent.mousewheel = 'mouse-wheel';
    MapEvent.pointerdown = 'pointer-down';
    MapEvent.pointerenter = 'pointer-enter';
    MapEvent.pointerleave = 'pointer-leave';
    MapEvent.pointermove = 'pointer-move';
    MapEvent.pointerup = 'pointer-up';
    MapEvent.resize = 'pointer-up';
    MapEvent.popupvisible = 'popup-visible';
    return MapEvent;
}());
export default MapEvent;
